import { render } from "./DocumentsDansukHome.vue?vue&type=template&id=1e36317f&scoped=true"
import script from "./DocumentsDansukHome.vue?vue&type=script&lang=js"
export * from "./DocumentsDansukHome.vue?vue&type=script&lang=js"

import "./DocumentsDansukHome.vue?vue&type=style&index=0&id=1e36317f&scoped=true&lang=scss"

import exportComponent from "/Users/berkuralcan/Documents/dev/webdev/dansuk-engineering-dashboard-v3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e36317f"]])

export default __exports__